module.exports = __webpack_public_path__ + "img/rule40.png";